import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';

import _ from 'lodash';
import Immutable from 'immutable';

import { QueryPaginatedSelection } from '@components/Inputs';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { CStatusIndicator } from '@ts/ui-models';

import StatusInput from '../Status/StatusInput';

// Due to the fact sometimes we use ID and some other times we use logicalId as main identifiers,
// we need a mapping for each case
// TODO: choose only onle
const ID_LOGICALID_MAPPING = {
  tsElementTypes: 'logicalId',
  taEventTypes: 'id',
};

class EntityFilter extends Component {
  constructor(props) {
    super(props);
    switch (props.entityId) {
      // case 'tsElement':
      //   this.itemsFetchUrl = '/api/v2/items';
      //   break;
      // case 'tsElementType':
      //     this.itemsFetchUrl = '/api/itemTypes';
      //     break;
      default:
        this.itemsFetchUrl = '/api/entitiesGeneric';
        break;
    }
  }

  render() {
    const selectedFilter = this.props.filterType
      ? this.props.filters.find(f => f.get('as') === this.props.filterType)
      : this.props.filters
        ? this.props.filters.getIn([0])
        : null;
    return (
      <Fragment>
        <FormControlLabel
          control={
            <Switch
              checked={this.props.enabled}
              onChange={this.onChangeCheckBoxEvent('enabled')}
              value="enabled"
              color="primary"
              disabled={this.props.disabled}
            />
          }
          label={this.props.t('Permission granted')}
        />
        <div style={{ marginTop: 30 }} />
        {this.props.filters &&
          this.props.allowIndividualInclusion &&
          this._renderFilterSelector(this.props.disabled || !this.props.enabled)}
        {(!selectedFilter || selectedFilter.get('as') === null) && this._renderIdSelector()}
        {selectedFilter && selectedFilter.get('as') !== null && this._renderSubentityFilter()}
      </Fragment>
    );
  }

  _renderSubentityFilter() {
    const selectedFilter = this.props.filters.find(f => f.get('as') === this.props.filterType);
    if (!selectedFilter) return null;
    switch (selectedFilter.get('as')) {
      case 'currentLocation':
      case 'defaultLocation':
        return (
          <Fragment>
            {this.props.allowIndividualInclusion && (
              <QueryPaginatedSelection
                upperExtraComponent={
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.props.includeAll}
                        onChange={this.onChangeCheckBoxEvent('includeAll', false)}
                        value="includeAll"
                        color="primary"
                        disabled={this.props.disabled || !this.props.enabled}
                      />
                    }
                    label={this.props.t('Include all')}
                  />
                }
                app={this.props.app}
                data={this.props.data}
                title={`${this.props.t('Include')}`}
                selectedIds={this.props.filterEntities}
                columns={this._entityColumns()}
                pkColumn={'id'}
                itemsFetchUrl={'/api/v2/items'}
                fnChipCaption={item => item.get('name')}
                onChangeSelected={this.onChangeIdSelector('filterEntities', selectedFilter.get('as'))}
                disabled={this.props.disabled || this.props.includeAll || !this.props.enabled}
                fetchData={{ filters: { location: { isAlive: true } } }}
              />
            )}
          </Fragment>
        );
        break;
      case 'status':
        return this._renderStatusIndicatorSelector();
        break;
      case 'itemType':
        return this._renderSelector('tsElementTypes', '/api/itemTypes', 'itemTypes');
      case 'eventType':
        return this._renderSelector('taEventTypes', '/api/eventTypes', 'eventTypes');
      case 'taskType':
        return this._renderSelector('taTaskTypes', '/api/taskTypes', 'taskTypes');
      default:
        return null;
        break;
    }
  }

  _renderFilterSelector(fDisabled) {
    const { filters } = this.props;
    const selectedValue = this.props.filters.find(f => f.get('as') === this.props.filterType);
    return (
      <Fragment>
        <FormControl>
          <InputLabel id="select-filter-label">Filter type</InputLabel>
          <Select
            id="select-filter"
            value={selectedValue ? selectedValue : ''}
            onChange={this._onChangeFilterType}
            disabled={fDisabled}
            style={{ width: '220px' }}
          >
            {filters.map(filter => {
              return (
                <MenuItem key={filter.get('as')} value={filter}>
                  {filter.get('name')}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </Fragment>
    );
  }

  _onChangeFilterType = event => {
    this.onChangeAclData([
      { prop: 'filterType', value: event.target.value.get('as') },
      { prop: 'filterEntities', value: [] },
    ]);
  };

  _renderIdSelector() {
    return (
      <Fragment>
        {this.props.allowIndividualInclusion && (
          <QueryPaginatedSelection
            upperExtraComponent={
              <FormControlLabel
                control={
                  <Switch
                    checked={this.props.includeAll}
                    onChange={this.onChangeCheckBoxEvent('includeAll')}
                    value="includeAll"
                    color="primary"
                    disabled={this.props.disabled || !this.props.enabled}
                  />
                }
                label={this.props.t('Include all')}
              />
            }
            app={this.props.app}
            data={this.props.data}
            title={`${this.props.t('Include')}`}
            selectedIds={this.props.enabled ? (this.props.includeAll ? [] : this.props.includeEntities) : []}
            columns={this._entityColumns()}
            pkColumn={'id'}
            itemsFetchUrl={this.itemsFetchUrl}
            fnChipCaption={item => item.get('name')}
            onChangeSelected={this.onChangeIdSelector('includeEntities')}
            disabled={this.props.disabled || this.props.includeAll || !this.props.enabled}
            fetchData={
              this.itemsFetchUrl === '/api/entitiesGeneric' && {
                entityId: this.props.entityId,
              }
            }
            columnToRetrieve={'logicalId'}
            returnLogicalId
          />
        )}
        {this.props.allowIndividualExclusion && (
          <Fragment>
            <div style={{ marginTop: 30 }} />
            <QueryPaginatedSelection
              app={this.props.app}
              data={this.props.data}
              title={`${this.props.t('Exclude')}`}
              selectedIds={this.props.enabled ? (this.props.includeAll ? this.props.excludeEntities : []) : []}
              columns={this._entityColumns()}
              pkColumn={'id'}
              itemsFetchUrl={this.itemsFetchUrl}
              itemsDataPath={'itemIds'}
              fnChipCaption={item => item.get('name')}
              onChangeSelected={this.onChangeIdSelector('excludeEntities')}
              disabled={this.props.disabled || !this.props.includeAll || !this.props.enabled}
              fetchData={
                this.itemsFetchUrl === '/api/entitiesGeneric' && {
                  entityId: this.props.entityId,
                }
              }
              columnToRetrieve={'logicalId'}
              returnLogicalId
            />
          </Fragment>
        )}
      </Fragment>
    );
  }

  _renderStatusIndicatorSelector() {
    const fDisabled = this.props.disabled || this.props.includeAll || !this.props.enabled;
    return (
      <Fragment>
        <FormControlLabel
          control={
            <Switch
              checked={this.props.includeAll}
              onChange={this.onChangeCheckBoxEvent('includeAll')}
              value="includeAll"
              color="primary"
              disabled={this.props.disabled || !this.props.enabled}
            />
          }
          label={this.props.t('Include all')}
        />
        <StatusInput
          app={this.props.app}
          data={this.props.data}
          mode={this.props.mode}
          title={this.props.t('Status')}
          statesList={this.props.includeEntities.map(i => new CStatusIndicator(i))}
          onChangeList={newList => {
            this.onChangeIncludedStatus(newList);
          }}
          fAllowAdd={!fDisabled}
          fAllowDelete={!fDisabled}
        />
      </Fragment>
    );
  }

  _renderSelector(entity, itemsFetchUrl, itemsDataPath) {
    const selectedFilter = this.props.filters.find(f => f.get('as') === this.props.filterType);
    return (
      <Fragment>
        <div style={{ marginTop: 30 }} />
        <FormControlLabel
          control={
            <Switch
              checked={this.props.includeAll}
              onChange={this.onChangeCheckBoxEvent('includeAll')}
              value="includeAll"
              color="primary"
              disabled={this.props.disabled || !this.props.enabled}
            />
          }
          label={this.props.t('Include all')}
        />
        <QueryPaginatedSelection
          data={this.props.data}
          app={this.props.app}
          title={this.props.includeAll ? `${this.props.t('Exclude')}` : `${this.props.t('Include')}`}
          selectedIds={this.props.filterEntities}
          columns={this._entityColumns()}
          pkColumn={'id'}
          itemsFetchUrl={itemsFetchUrl}
          itemsDataPath={itemsDataPath}
          fnChipCaption={item => item.get('name')}
          onChangeSelected={this.onChangeIdSelector('filterEntities', selectedFilter.get('as'))}
          disabled={this.props.disabled || !this.props.enabled}
          returnLogicalId={ID_LOGICALID_MAPPING[entity] === 'logicalId'}
          columnToRetrieve={ID_LOGICALID_MAPPING[entity]}
          clearSelectedItemsOnNewFetch
        />
      </Fragment>
    );
  }

  _entityColumns() {
    return [
      {
        fnLabel: () => `${this.props.t('ID')}`,
        name: 'id',
        fHidden: true,
      },
      {
        fnLabel: () => `${this.props.t('Logical Id')}`,
        name: 'logicalId',
        rawValue: o => o.get('logicalId'),
      },
      {
        fnLabel: () => `${this.props.t('Name')}`,
        name: 'name',
        rawValue: o => o.get('name'),
      },
    ];
  }

  onChangeIdSelector =
    (prop, filter = null) =>
      value => {
        this.onChangeAclData([
          { prop, value },
          { prop: 'filterType', value: filter },
        ]);
      };

  onChangeCheckBoxEvent =
    (prop, allowIndividualExclusion = true) =>
      event => {
        if (prop === 'includeAll' && event.target.checked && !allowIndividualExclusion) {
          this.onChangeAclData([{ prop: 'filterEntities', value: null }]);
        }
        this.onChangeAclData([{ prop, value: event.target.checked }]);
      };

  onChangeIncludedStatus = value => {
    this.onChangeAclData([
      { prop: 'includeEntities', value },
      { prop: 'filterType', value: 'status' },
    ]);
  };

  onChangeAclData = data => {
    data.map(d => this.props.onChange(d.prop, d.value));
  };
}

EntityFilter.propTypes = {
  entityId: PropTypes.string.isRequired,
};

EntityFilter.defaultProps = {
  enabled: false,
  includeAll: true,
  includeEntities: [],
  excludeEntities: [],
};
export default EntityFilter;
